import React from 'react'
import LoadingComponent from './LoadingComponent.js'
import ChartComponent from './ChartComponent.js'
import TableData from '../ReportComponents/component/TableData.js';
import SummaryMessage from '../SummaryComponents/component/SummaryMessage';
import { setInsightFunction } from '../../actions/index'
// import axios from 'axios';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getParameters } from '../../../adminpanel/components/commonComponents/Helper.js';
var base64 = require('base-64');
//The component is called from the chart or other main components
//Once the component is initialized, an AJAX call is done to get all the charts to be shown based on selection done for auto analysis
//The insight rules are saved in database as it is needed to be configured per client bases and have complex rules based on input type and from where the auto analysis is viewed
//Once the list of all the outputs to be shown in sidebar insight are received, AJAX calls are done to get the data for each of them
//On each success, a list of outputs for which data is received is maintained in the state
//On each render the highest unbroken sequence of numbers is checked from data loaded
//Each compoennts are loaded as they are loaded
var insightMargin = {
    margin: "-3% 3% 3% 3%",
    fontSize: '17.5px'
};

var descriptionLabelStyle = {
    width: '100%',
    padding: "15px 0px"
};

var descriptionDivStyle = {
    padding: '0px',
    float: "left"
};

var descriptionFeedbackStyle = {
    padding: '6px 5px 0px 0px',
    fontSize: "15px",
    textAlign: "right"
};

var likeDislikeMargin = {
    marginRight: "5px"
}

var insightTypeGlobal = null

var includeBreakUp = ''
var excludeBreakUp = ''

var urlList = [];
class SidebarInsight extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            summary: 0,
            growth: 0,
            finalResult: [],
            shortName: [],
            totalResult: 0,
            resultCount: 0,
            dataLoaded: [],
            rankToConsider: {}
        }
        this.closeSidebarInsight = this.closeSidebarInsight.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        
        var date = (nextProps.date == 'undefined' || nextProps.date == 'null') && nextProps.insightType != "deepInsight" ? null : nextProps.date;
        var point = (nextProps.point == 'undefined' || nextProps.point == 'null') && nextProps.insightType != "deepInsight" ? null : nextProps.point;
        var propsCheck = this.arePrevAndNextPropsEqual(this.props, nextProps);
        if ((date || point) && !propsCheck) {
            this.setState({ dataLoaded: [] });
            if (document.getElementById('SidebarInsightDiv') && (!document.getElementById('SidebarInsightDiv').style.width || document.getElementById('SidebarInsightDiv').style.width == '0px')) {
                // openSidebar('SidebarInsightDiv', "390px");
                if (jQuery(window).width() >= mobile_width) {
                    openSidebar('SidebarInsightDiv', '500px');
                } else openSidebar('SidebarInsightDiv', filter_mobile_width);

                
            }
            
            // if (!document.getElementById('main-content').style.width || document.getElementById('main-content').style.width == '0px') {
                // jQuery("#main-content").css("marginRight", "380px");
                var url = document.location.pathname;
                if (url == '/chart/chartData' && highChartsDiv)
                    highChartsDiv.reflow();
            // }

            metricGlobal = nextProps.mainMetric;
            if (nextProps.insightType != "deepInsight")
                this.loadData(nextProps);
            else this.deepInsightLoadData(nextProps);
        }
        // else {
        //     metricGlobal = nextProps.mainMetric;
        //     this.loadData(nextProps);
        // }
    }
    componentDidMount() {
        
        var reactObj = null;
        // if (this.state.newPage || this.state.insightType == 'deepInsight') {
        if (this.state.newPage) {
            reactObj = this.state;
            if (this.state.insightType != "deepInsight")
                this.loadData(reactObj);
            else this.deepInsightLoadData(reactObj);
        } else {
            if (!document.getElementById('SidebarInsightDiv').style.width || document.getElementById('SidebarInsightDiv').style.width == '0px') {
                // openSidebar('SidebarInsightDiv', "390px");
                if (jQuery(window).width() >= mobile_width && jQuery(window).width() >= tablet_width) {
                    openSidebar('SidebarInsightDiv', '500px');
                } else openSidebar('SidebarInsightDiv', '100%');

                // if (!document.getElementById('main-content').style.width || document.getElementById('main-content').style.width == '0px') {
                    // jQuery("#main-content").css("marginRight", "380px");
                    var url = document.location.pathname;
                    if (url == '/chart/chartData' && highChartsDiv)
                        highChartsDiv.reflow();
                // }
            }
            this.setState({ summary: null, growth: null, chartData1: null, chartData2: null, chartData3: null });
            if (this.props.point && this.props.insightCategory == 'report') {
                // closeSidebar('FilterDiv');
                reactObj = this.props;
            }
            else
                reactObj = this.state;
            
            this.state.insightType != "deepInsight" ? this.loadData(reactObj) : this.deepInsightLoadData(reactObj)        
            // this.loadData(reactObj);
        }
    }
    componentDidUpdate = () => {
        // Add minus icon for collapse element which is open by default
        jQuery(".collapse.show").each(function(){
            jQuery(this).prev(".card-header").find('.customIcon').addClass("fa-angle-up").removeClass("fa-angle-right")
        });
        
        // Toggle plus minus icon on show hide of collapse element
        jQuery(".collapse").on('show.bs.collapse', function(){
        	jQuery(this).prev(".card-header").find('.customIcon').removeClass("fa-angle-right").addClass("fa-angle-up");
        }).on('hide.bs.collapse', function(){
        	jQuery(this).prev(".card-header").find('.customIcon').removeClass("fa-angle-up").addClass("fa-angle-right");
        });
    }
    deepInsightLoadData = (reactObj) => {
                
        let urlInsightMetric = getParameters('insightMetric')
        if (!reactObj.insightMetric && !urlInsightMetric) {
            return null;
        }
        var that = this;

        let point = reactObj.point
        let property = reactObj.property
        property = property ? property : reactObj.insightProperty
        if (point === 'all' || point === 'page') {
            property = point === 'page' ? null : property
            point = ''
        }

        var chartName = reactObj.chart;
        let period = (reactObj.date && nonTimeseriesChartCat.toString().toLowerCase().indexOf(chartName.toLowerCase()) == -1) ? reactObj.period : '';
        // property = ''
        if (reactObj.newPage) {
            period = getParameters('period');
            property = getParameters('property');
        }
        var dataset = JSON.parse(localStorage.Dataset);
        var userId = reactObj.authData ? reactObj.authData.userId : null;
        var authorization_value = null;
        authorization_value = "Basic " + btoa(userId + ":");
        let metricToUse = reactObj.pointMetric ? reactObj.pointMetric : null
        if (!metricToUse) {
            // metricToUse = period ? reactObj.point && reactObj.point!='Total' ? reactObj.point : reactObj.metric : reactObj.metric            
            metricToUse = reactObj.metric
        }

        if (!metricToUse && reactObj.newPage) metricToUse = getParameters('metric');
        // rootCauseClickedMetric = metricToUse.split(',')[0] 

        let params = {
            "selectedMetric": refineURLData(metricToUse), "selectedProperty": refineURLData(property), "breakUp": refineURLData(reactObj.breakup), "includeBreakUp": refineURLData(reactObj.include), "excludeBreakUp": refineURLData(reactObj.exclude), "point": refineURLData(point), "date": refineURLData(reactObj.date ? reactObj.date : reactObj.insightDate), "startDate": refineURLData(reactObj.startDate), "endDate": refineURLData(reactObj.endDate), "limit": refineURLData(reactObj.limit), "sortOrder": refineURLData(reactObj.sortOrder ? reactObj.sortOrder : getParameters('sortOrder')), insightMetric: refineURLData(reactObj.insightMetric), siteId: refineURLData(dataset.siteId), toolId: refineURLData(dataset.toolId), dashboard: true, type: 1, "period": refineURLData(period ? period : reactObj.insightPeriod)
        }
        CallAPI('GET', '/app/deepInsight', null, params, 0, function (data) {
            checkIfSessionTimedOut(data)
            if (data) {
                
                var startDate = reactObj.startDate;
                var endDate = reactObj.endDate;
                var deepInsightDateAvailable = data.dateAvailable;
                var totalResult = !deepInsightDateAvailable ? 1 : data.rule.metric.length;//number of charts to display
                //startDate,endDate = normal, dateString=To display date, breakupstring = to display breakup of all charts,
                var topProperty = data ? data['topProperty'] : null;
                var topPropertyValues = data ? data['topPropertyValues'] : null;
                let topPropertyValuesArray = topPropertyValues && topPropertyValues['across'] ? topPropertyValues['across'].split(',') : null
                that.setState({ startDate: startDate, endDate: endDate, displayDate: data['dateString'], breakupToShow: data['breakupString'], compareDate: data['compareDateString'], totalResult: totalResult, resultCount: 0, newData: data.newData, allProperty: data.allProperty, finalResult: [], dataLoaded: [], chartType: data.rule.chart, callType: data.rule.callType, metric: data.rule.metric, topProperty: topProperty, topPropertyValues: topPropertyValues, information: [], descriptionRules: data.descriptionRules, headingRules: data.headingRules, function: data.rule.function, extendedFunction: data.rule.extendedFunction});
                //Get data for each insight component
                var index = 0;
                var preindex = null;
                // totalResult = 4;
                let callType = data.rule.callType;
                while (index < totalResult) {
                    
                    if (that.state.dataLoaded == -1 || that.state.dataLoaded == -2)
                        break;
                    if (preindex == index) {
                        if (that.state.dataLoaded[that.state.dataLoaded.length - 1] == (index + 1))
                            index++;
                        continue;
                    }
                    preindex = index;
                    var functionData = null;
                    var functionDataSecond = null;
                    var ruleUse = data.rule.use[index] ? data.rule.use[index].split('_') : [];
                    if (data.rule.use[index]) {
                        if (ruleUse[0] == 'across' && ruleUse[1] != 'f1') {
                            functionData = data.rule.function[index] + '_+_' + ruleUse[0];
                            functionDataSecond = data.rule.function[index] + '_+_' + ruleUse[0] + '' + (data.rule.extendedFunction[index] ? '_' + data.rule.extendedFunction[index] : '');
                        } else {
                            functionData = data.rule.function[index];
                            functionDataSecond = data.rule.function[index] + '' + (data.rule.extendedFunction[index] ? '_' + data.rule.extendedFunction[index] : '');
                        }
                    }
                    var descriptionSign = data.rule.descriptionSign;
                    descriptionSign = descriptionSign ? descriptionSign[index] : '';

                    var currentCallType = callType[index];

                    if (currentCallType == 'direct') {
                        if (data.rule.chart[index] == 'Summary') {
                            that.summary(startDate, endDate, null, data.rule.metric[index], data.newData['breakUp'], data.newData['includeBreakUp'], data.newData['excludeBreakUp'], index, data.newData['periodComparison']);
                        }
                        else {  // for chart                            
                            var currentStartDate = decodeURIComponent(startDate)
                            var currentEndDate = decodeURIComponent(endDate)
                            let period = null
                            if (data.rule.chart[index] == 'Trend' || data.rule.chart[index] == 'Line') {
                                if (data.newData['trendStartDate']) {
                                    currentStartDate = data.newData['trendStartDate']
                                    currentEndDate = data.newData['trendEndDate']
                                }
                                period = data.newData['period']
                            }
                            topProperty = topProperty ? topProperty : that.state.topProperty
                            let tempProperty = ruleUse && topProperty ? topProperty[ruleUse[0]] : topProperty['C']
                            let breakupToUse = data.newData['breakUp']
                            if (ruleUse[1] && tempProperty && topPropertyValuesArray) {
                                breakupToUse = breakupToUse ? (breakupToUse + ',' + topPropertyValuesArray[index-1]) : breakupToUse;
                            }
                                                        
                            // that.chart(currentStartDate, currentEndDate, tempProperty, data.rule.metric[index], data.newData['breakUp'], data.newData['includeBreakUp'], data.newData['excludeBreakUp'], data.rule['order'][index], data.rule['limit'][index], data.rule['chart'][index], period, null, index, data.newData['periodComparison']);

                            that.chart(currentStartDate, currentEndDate, tempProperty, data.rule.metric[index], breakupToUse, data.newData['includeBreakUp'], data.newData['excludeBreakUp'], data.rule['order'][index], data.rule['limit'][index], data.rule['chart'][index], period, null, index);
                        }
                    } else {
                        // if (index == 1) {
                        //     continue;
                            // var metricTouse = "actual_sales;change,actual_sales;growth,actual_sales;percentageshare,actual_sales;sum"
                        // }
                        if (data.rule.output[index] == "null") {
                            //last parameter tells should function call wait till ajax completes or not
                            that.deepInsightData(startDate, endDate, data.rule.function[index], data.rule.metric[index], data.rule.order[index], data.rule.limit[index], data.rule.chart[index], data.rule.output[index], data.rule.use[index], data.rule.extendedFunction[index], data.rule.descriptionLimit[index], descriptionSign, data.headingRules[functionData], data.descriptionRules[functionDataSecond], index, 0, deepInsightDateAvailable, data.newData, data.allProperty);
                        }
                        else {
                            //last parameter tells should function call wait till ajax completes or not
                            that.deepInsightData(startDate, endDate, data.rule.function[index], data.rule.metric[index], data.rule.order[index], data.rule.limit[index], data.rule.chart[index], data.rule.output[index], data.rule.use[index], data.rule.extendedFunction[index], data.rule.descriptionLimit[index], descriptionSign, data.headingRules[functionData], data.descriptionRules[functionDataSecond], index, 1, deepInsightDateAvailable, data.newData, data.allProperty);
                        }
                    }
                    index++;
                }
            }
            else that.setState({ result: "no data found" });
        }, this.props.authData)

        /* Commented below jQuery.ajax api call & changed it to above CallAPI method */
        // jQuery.ajax({
        //     type: 'get',
        //     async: true,
        //     data: {
        //         "selectedMetric": refineURLData(metricToUse), "selectedProperty": refineURLData(property), "breakUp": refineURLData(reactObj.breakup), "includeBreakUp": refineURLData(reactObj.include), "excludeBreakUp": refineURLData(reactObj.exclude), "point": refineURLData(point), "date": refineURLData(reactObj.date? reactObj.date : reactObj.insightDate), "startDate": refineURLData(reactObj.startDate), "endDate": refineURLData(reactObj.endDate), "limit": refineURLData(reactObj.limit), "sortOrder": refineURLData(reactObj.sortOrder), insightMetric: refineURLData(reactObj.insightMetric), siteId: refineURLData(dataset.siteId), toolId: refineURLData(dataset.toolId), dashboard: true, type: 1, "period": refineURLData(period)
        //     },            
        //     headers: { Authorization: authorization_value },
        //     url: '/app/deepInsight',
        //     success: function (data) {
        //         checkIfSessionTimedOut(data)
        //         data = JSON.parse(data);
        //         if (data) {
        //             var startDate = reactObj.startDate;
        //             var endDate = reactObj.endDate;
        //             var deepInsightDateAvailable = data.dateAvailable;
        //             var totalResult = !deepInsightDateAvailable ? 1 : data.rule.chart.length;//number of charts to display
        //             //startDate,endDate = normal, dateString=To display date, breakupstring = to display breakup of all charts,
        //             var topProperty = data ? data['topProperty'] : null;
        //             var topPropertyValues = data ? data['topPropertyValues'] : null;
        //             that.setState({ startDate: startDate, endDate: endDate, displayDate: data['dateString'], breakupToShow: data['breakupString'], compareDate: data['compareDateString'], totalResult: totalResult, resultCount: 0, newData: data.newData, allProperty: data.allProperty, finalResult: [], dataLoaded: [], chartType: data.rule.chart, callType: data.rule.callType, metric: data.rule.metric, topProperty: topProperty, topPropertyValues: topPropertyValues, information: [] });
        //             //Get data for each insight component
        //             var index = 0;
        //             var preindex = null;
        //             // totalResult = 3;
        //             let callType = data.rule.callType;
        //             while (index < totalResult) {
        //                 if (that.state.dataLoaded == -1 || that.state.dataLoaded == -2)
        //                     break;
        //                 if (preindex == index) {
        //                     if (that.state.dataLoaded[that.state.dataLoaded.length - 1] == (index + 1))
        //                         index++;
        //                     continue;
        //                 }
        //                 preindex = index;
        //                 var functionData = null;
        //                 var functionDataSecond = null;
        //                 var ruleUse = data.rule.use[index] ? data.rule.use[index].split('_') : [];                        
        //                 if (data.rule.use[index]) {
        //                     if (ruleUse[0] == 'across' && ruleUse[1] != 'f1') {
        //                         functionData = data.rule.function[index] + ' + ' + ruleUse[0];
        //                         functionDataSecond = data.rule.function[index] + ' + ' + ruleUse[0] + '' + (data.rule.extendedFunction[index] ? '_' + data.rule.extendedFunction[index] : '');
        //                     } else {
        //                         functionData = data.rule.function[index];
        //                         functionDataSecond = data.rule.function[index] + '' + (data.rule.extendedFunction[index] ? '_' + data.rule.extendedFunction[index] : '');
        //                     }
        //                 }
        //                 var descriptionSign = data.rule.descriptionSign;
        //                 descriptionSign = descriptionSign ? descriptionSign[index] : '';

        //                 var currentCallType = callType[index];

        //                 if(currentCallType == 'direct') {
        //                     if (data.rule.chart[index] == 'Summary') {
        //                         that.summary(startDate, endDate, null, data.rule.metric[index], data.newData['breakUp'], data.newData['includeBreakUp'], data.newData['excludeBreakUp'], index, data.newData['periodComparison']);
        //                     }
        //                     else {  // for chart
        //                         var currentStartDate = startDate
        //                         var currentEndDate = endDate
        //                         let period = null
        //                         if(data.rule.chart[index] == 'Trend' || data.rule.chart[index] == 'Line') {
        //                             if(data.newData['trendStartDate']) {
        //                                 currentStartDate = data.newData['trendStartDate']
        //                                 currentEndDate = data.newData['trendEndDate']
        //                             }                                    
        //                             period = data.newData['period']
        //                         }
        //                         topProperty = topProperty ? topProperty : that.state.topProperty                                
        //                         let tempProperty = ruleUse && topProperty ? topProperty[ruleUse[0]] : null                                
        //                         that.chart(currentStartDate, currentEndDate, tempProperty, data.rule.metric[index], data.newData['breakUp'], data.newData['includeBreakUp'], data.newData['excludeBreakUp'], data.rule['order'][index], data.rule['limit'][index], data.rule['chart'][index], period, index, data.newData['periodComparison']);
        //                     }
        //                 } else {
        //                     if (data.rule.output[index] == "null") {
        //                         //last parameter tells should function call wait till ajax completes or not
        //                         that.deepInsightData(startDate, endDate, data.rule.function[index], data.rule.metric[index], data.rule.order[index], data.rule.limit[index], data.rule.chart[index], data.rule.output[index], data.rule.use[index], data.rule.extendedFunction[index], data.rule.descriptionLimit[index], descriptionSign, data.headingRules[functionData], data.descriptionRules[functionDataSecond], index, 0, deepInsightDateAvailable, data.newData, data.allProperty);
        //                     }
        //                     else {
        //                         //last parameter tells should function call wait till ajax completes or not
        //                         that.deepInsightData(startDate, endDate, data.rule.function[index], data.rule.metric[index], data.rule.order[index], data.rule.limit[index], data.rule.chart[index], data.rule.output[index], data.rule.use[index], data.rule.extendedFunction[index], data.rule.descriptionLimit[index], descriptionSign, data.headingRules[functionData], data.descriptionRules[functionDataSecond], index, 1, deepInsightDateAvailable, data.newData, data.allProperty);
        //                     }
        //                 }                        
        //                 index++;
        //             }
        //         }
        //         else that.setState({ result: "no data found" });
        //     }
        // });
    }
    deepInsightData = (startDate, endDate, functionData, metric, order, limit, chart, output, use, extendedFunction, descriptionLimit, descriptionSign, headingRules, descriptionRules, index, wait, deepInsightDateAvailable, newData, allProperty) => {
        
        var that = this;
        var dataset = JSON.parse(localStorage.Dataset);
        let postData = {
            'newData': this.state.newData,
            'allProperty': this.state.allProperty,
            'userId': this.props.authData.userId
        }
        if (this.state.topProperty) {
            postData['topProperty'] = this.state.topProperty
        }
        if (this.state.topPropertyValues) {
            postData['topPropertyValues'] = this.state.topPropertyValues
        }
        let params = { 'siteId': dataset.siteId, 'toolId': dataset.toolId, 'function': functionData, 'metric': metric, 'order': order, 'limit': limit, 'chart': chart, 'output': output, 'use': use, 'extendedFunction': extendedFunction, 'descriptionLimit': descriptionLimit, 'descriptionSign': descriptionSign, 'headingRules': headingRules, 'descriptionRules': descriptionRules }

        CallAPI('POST', '/app/deepInsightData', postData, params, 0, function (response) {
            checkIfSessionTimedOut(response)
            var finalResultLocal = that.state.finalResult;
            var dataLoaded = that.state.dataLoaded;
            if (response['insights'] == -1) {    // No spike or dip available
                finalResultLocal[index] = -1;
                dataLoaded = -1;
            } else if (response['insights'] == -2) { // No date range specified by user
                finalResultLocal[index] = -2;
                dataLoaded = -2;
            } else {
                finalResultLocal[index] = response;
                //Set information that data for this component if loaded by its index
                var topProperty = response ? response['topProperty'] : null;
                var topPropertyValues = response ? response['topPropertyValues'] : null;
                dataLoaded.push(index);
            }
            that.setState({
                topProperty: topProperty,
                topPropertyValues: topPropertyValues,
                finalResult: finalResultLocal,
                dataLoaded: dataLoaded
            });
        }, this.props.authData)

        /* Commented below jQuery.ajax api call & changed it to above CallAPI method */
        // var postData = new FormData();
        // postData.append('newData', JSON.stringify(this.state.newData));
        // postData.append('allProperty', JSON.stringify(this.state.allProperty));
        // if (this.state.topProperty) {
        //     postData.append('topProperty', JSON.stringify(this.state.topProperty));
        // }
        // if (this.state.topPropertyValues) {
        //     postData.append('topPropertyValues', JSON.stringify(this.state.topPropertyValues))
        // }

        // var async = wait ? false : true;

        // var userId = this.props.authData.userId;
        // var authorization_value = null;
        // authorization_value = "Basic " + btoa(userId + ":");
        // var dataset = JSON.parse(localStorage.Dataset);

        // postData.append('userId', userId)

        // let params = { siteId: dataset.siteId, toolId: dataset.toolId, userId: userId, function: encodeURIComponent(functionData), metric: encodeURIComponent(metric), order: encodeURIComponent(order), limit: encodeURIComponent(limit), chart: encodeURIComponent(chart), output: encodeURIComponent(output), use: encodeURIComponent(use), extendedFunction: encodeURIComponent(extendedFunction), descriptionLimit: encodeURIComponent(descriptionLimit), descriptionSign: encodeURIComponent(descriptionSign), headingRules: encodeURIComponent(headingRules), descriptionRules: encodeURIComponent(descriptionRules) }                

        // let postData = JSON.stringify({ newData: JSON.stringify(newData), allProperty: JSON.stringify(allProperty), topProperty: JSON.stringify(this.state.topProperty), topPropertyValues: JSON.stringify(this.state.topPropertyValues)})
        // jQuery.ajax({
        //     type: 'POST',
        //     url: `/app/deepInsightData?toolId=${dataset.toolId}&siteId=${dataset.siteId}&function=` + (functionData) + '&metric=' + (metric) + '&order=' + (order) + '&limit=' + (limit) + '&chart=' + (chart) + '&output=' + (output) + '&use=' + (use) + '&extendedFunction=' + (extendedFunction) + '&descriptionLimit=' + (descriptionLimit) + '&descriptionSign=' + (descriptionSign) + '&headingRules=' + (headingRules) + '&descriptionRules=' + (descriptionRules),
        //     headers: { Authorization: authorization_value },
        //     data: postData,
        //     async: async,
        //     contentType: false,
        //     processData: false,
        //     success: function (response) {
        //         checkIfSessionTimedOut(response)
        //         response = JSON.parse(response);
        //         var finalResultLocal = that.state.finalResult;
        //         var dataLoaded = that.state.dataLoaded;
        //         if (response['insights'] == -1) {    // No spike or dip available
        //             finalResultLocal[index] = -1;
        //             dataLoaded = -1;
        //         } else if (response['insights'] == -2) { // No date range specified by user
        //             finalResultLocal[index] = -2;
        //             dataLoaded = -2;
        //         } else {
        //             finalResultLocal[index] = response;
        //             //Set information that data for this component if loaded by its index
        //             var topProperty = response ? response['topProperty'] : null;
        //             var topPropertyValues = response ? response['topPropertyValues'] : null;
        //             dataLoaded.push(index);
        //         }
        //         that.setState({
        //             topProperty: topProperty,
        //             topPropertyValues: topPropertyValues,
        //             finalResult: finalResultLocal,
        //             dataLoaded: dataLoaded
        //         });
        //     }
        // });
    }
    loadData = (reactObj) => { 
        let newPage = reactObj.newPage
        newPage = getParameters('question') ? true : false;
        let property = reactObj.insightProperty ? reactObj.insightProperty : reactObj.property
        let propertyCase1 = getParameters('property')
        propertyCase1 = decodeURIComponent(refineURLData(propertyCase1))
        let propertyCase2 = decodeURIComponent(refineURLData(property))
        let case1 = getParameters('question') ? propertyCase2 == propertyCase1 ? true : false : true;
        // Prevent the case when point is property and is coming with dimension name. Ex. Mumbai;city
        let pointCase = reactObj.point && reactObj.point == refineURLData(property) ? reactObj.point.split(';')[1] ? reactObj.point.split(';')[1] : true : newPage ? reactObj.point : null
        // if ((!reactObj.point || !case1 || pointCase) && newPage) {
        if ((!reactObj.point || !case1) && newPage) {
        // if(!reactObj.point || !case1){
            return null;
        }
        var that = this;
        // var chartName = newPage ? getParameters('chartCat') : reactObj.chart;
        var chartName = reactObj.chart;
        // var startDate = newPage ? getParameters('startDate') : reactObj.startDate
        // var endDate = newPage ? getParameters('endDate') : reactObj.endDate
        var dateToBeUsed = reactObj.insightDate;
        
        // var period = newPage ? getParameters("period") : ((reactObj.date && nonTimeseriesChartCat.toString().toLowerCase().indexOf(chartName.toLowerCase()) == -1) ? (refineURLData(reactObj.insightPeriod) ? reactObj.insightPeriod : reactObj.period) : '');
        var period = ((reactObj.date && nonTimeseriesChartCat.toString().toLowerCase().indexOf(chartName.toLowerCase()) == -1) ? (refineURLData(reactObj.insightPeriod) ? reactObj.insightPeriod : reactObj.period) : reactObj.period ? reactObj.period : '');

        let point = refineURLData(reactObj.point) ? reactObj.point : getParameters('point')  
        
        if (point === 'all' || point === 'page') {
            property = point === 'page' ? null : property
            point = ''
        }
        property = newPage ? getParameters('property') : property;

        var dataset = JSON.parse(localStorage.Dataset);
        var userId = reactObj.authData ? reactObj.authData.userId : null;
        var authorization_value = null;
        authorization_value = "Basic " + btoa(userId + ":");
        let metricToUse = reactObj.pointMetric ? reactObj.pointMetric : reactObj.metric
        metricToUse = metricToUse ? metricToUse : decodeURIComponent(getParameters('metric'))

        let startDate = getParameters('startDate') ? decodeURIComponent(getParameters('startDate')) : reactObj.insightStartDate ? reactObj.insightStartDate : reactObj.startDate 
        let endDate = getParameters('endDate') ? decodeURIComponent(getParameters('endDate')) : reactObj.insightEndDate ? reactObj.insightEndDate : reactObj.endDate
        let breakup = reactObj.breakup ? refineURLData(reactObj.breakup) : decodeURIComponent(getParameters('breakup'))
        let include = includeBreakUp = reactObj.include ? refineURLData(reactObj.include) : decodeURIComponent(getParameters('include'))
        let exclude = excludeBreakUp = reactObj.exclude ? refineURLData(reactObj.exclude) : decodeURIComponent(getParameters('exclude'))

        let params = {
            "metric": decodeURIComponent(refineURLData(metricToUse)), "property": decodeURIComponent(refineURLData(property)), "breakup": decodeURIComponent(refineURLData(breakup)), "includeBreakUp": decodeURIComponent(refineURLData(include)), "excludeBreakUp": decodeURIComponent(refineURLData(exclude)), "point": decodeURIComponent(refineURLData(point)), "date": decodeURIComponent(refineURLData(dateToBeUsed)), "startDate": decodeURIComponent(refineURLData(startDate)), "endDate": decodeURIComponent(refineURLData(endDate)), "period": decodeURIComponent(refineURLData(period)), "chart": decodeURIComponent(refineURLData(chartName)), "periodComparison": decodeURIComponent(refineURLData(reactObj.periodComparison)), "siteId": decodeURIComponent(refineURLData(dataset.siteId)), "toolId": decodeURIComponent(refineURLData(dataset.toolId)), "dashboard": true, 'sortOrder': decodeURIComponent(refineURLData(reactObj.insightSortOrder))
        }
        CallAPI('GET', '/app/getInsightRule', null, params, 0, function (data) {
            checkIfSessionTimedOut(data)
            if (data) {
                var params = data['params'];
                var startDate = data['startDate'];
                var endDate = data['endDate'];
                var adjustDateForTrendAssociative = data['adjustDateForTrendAssociative'];
                var periodComparison = data['periodComparison'];
                var totalResult = (params['chartType']).length;

                that.setState({ startDate: startDate, endDate: endDate, displayDate: data['dateString'], breakupToShow: data['breakupString'], includeToShow: data['includeBreakUpString'], excludeToShow: data['excludeBreakUpString'], chartType: params['chartType'], metric: params['metric'], header: params['header'], totalResult: totalResult, resultCount: 0, adjustDateForTrendAssociative: adjustDateForTrendAssociative, periodComparison: periodComparison, rankToConsider: data['rankToConsider'], trendCompareDates: data['trendCompareDates'], trendCompareCounter: 0, propertyArray: params['property'], breakupArray: params['breakup'], include: data['includeBreakUp'], exclude: data['exclude'], information: [], params: params });
                //Get data for each insight component

                for (var index = 0; index < totalResult; index++) {
                    let excludeBreakUpToUse = params['exclude'] ? params['exclude'][index] : excludeBreakUp
                    if (params['chartType'][index] == 'Summary') {
                        that.summary(decodeURIComponent(startDate), decodeURIComponent(endDate), decodeURIComponent(params['property'][index]), decodeURIComponent(params['metric'][index]), decodeURIComponent(params['breakup'][index]), decodeURIComponent(includeBreakUp), decodeURIComponent(excludeBreakUpToUse), index);
                    }
                    else {  // for chart
                        excludeBreakUpToUse = params['chartType'][index] == 'Line' ? null : excludeBreakUpToUse
                        that.chart(decodeURIComponent(startDate), decodeURIComponent(endDate), decodeURIComponent(params['property'][index]), decodeURIComponent(params['metric'][index]), decodeURIComponent(params['breakup'][index]), decodeURIComponent(includeBreakUp), decodeURIComponent(excludeBreakUpToUse), decodeURIComponent(params['sortOrder'][index]), decodeURIComponent(params['limit'][index]), params['metricRange'] ? decodeURIComponent(params['metricRange'][index]) : '', decodeURIComponent(params['chartType'][index]), decodeURIComponent(params['period'][index]), decodeURIComponent(params['reportTypeArray'][index]), index);
                    }
                }
            } else {    // Indicated there was some issue with the rules
                that.setState({ dataLoaded: -3 });
            }
        }, this.props.authData)

        /* Commented below jQuery.ajax api call & changed it to above CallAPI method */
        // jQuery.ajax({
        //     type: 'get',
        //     async: true,
        //     data: {
        //         "metric": refineURLData(metricToUse), "property": refineURLData(property), "breakup": refineURLData(breakup), "includeBreakUp": refineURLData(include), "excludeBreakUp": refineURLData(exclude), "point": refineURLData(point), "date": refineURLData(dateToBeUsed), "startDate": refineURLData(startDate), "endDate": refineURLData(endDate), "period": refineURLData(period), "chart": refineURLData(chartName), periodComparison: refineURLData(reactObj.periodComparison), siteId: refineURLData(dataset.siteId), toolId: refineURLData(dataset.toolId), dashboard: true
        //     },
        //     headers: { Authorization: authorization_value },
        //     url: '/app/getInsightRule',
        //     success: function (data) {
        //         checkIfSessionTimedOut(data)
        //         data = JSON.parse(data);
        //         if (data) {
        //             var params = data['params'];
        //             var startDate = data['startDate'];
        //             var endDate = data['endDate'];
        //             var adjustDateForTrendAssociative = data['adjustDateForTrendAssociative'];
        //             var periodComparison = data['periodComparison'];
        //             var totalResult = (params['chartType']).length;


        //             that.setState({ startDate: startDate, endDate: endDate, displayDate: data['dateString'], breakupToShow: data['breakupString'], includeToShow: data['includeBreakUpString'], excludeToShow: data['excludeBreakUpString'], chartType: params['chartType'], metric: params['metric'], header: params['header'], totalResult: totalResult, resultCount: 0, adjustDateForTrendAssociative: adjustDateForTrendAssociative, periodComparison: periodComparison, rankToConsider: data['rankToConsider'], trendCompareDates: data['trendCompareDates'], trendCompareCounter: 0, propertyArray: params['property'], breakupArray: params['breakup'], include: data['includeBreakUp'], exclude: data['excludeBreakUp'], information: [], params: params });
        //             //Get data for each insight component

        //             for (var index = 0; index < totalResult; index++) {
        //                 if (params['chartType'][index] == 'Summary') {
        //                     that.summary(startDate, endDate, params['property'][index], params['metric'][index], params['breakup'][index], includeBreakUp, excludeBreakUp, index);
        //                 }
        //                 else {  // for chart
        //                     that.chart(startDate, endDate, params['property'][index], params['metric'][index], params['breakup'][index], includeBreakUp, excludeBreakUp, params['sortOrder'][index], params['limit'][index], params['chartType'][index], params['period'][index], index);
        //                 }
        //             }
        //         } else {    // Indicated there was some issue with the rules
        //             that.setState({ dataLoaded: -3 });
        //         }
        //     }
        // });
    }
    summary = (startDate, endDate, property, metric, breakup, include, exclude, index, periodComparison) => {
        var that = this;
        var outputType = '';
        var periodComparison = insightTypeGlobal == "deepInsight" ? periodComparison : this.state.periodComparison;
        if (that.state.runRateIndex == index)
            outputType = 'runrate;1';
        else if (that.state.projectionIndex == index)
            outputType = 'projection';
        property = refineURLData(property) ? '' : property;
        urlList[index] = '/v1/trendChart?startData=' + startDate + '&endDate=' + endDate + '&property=' + property + '&selectedPropertyValue=&selectedMetric=' + metric + '&breakup=' + breakup + '&include=' + include + '&exclude=' + exclude + '&calculateGrowth=true&periodComparison=' + periodComparison + '&outputType=' + outputType + '&isInsight=true&chart=Table&returnType=total&type=summary';

        var dataset = JSON.parse(localStorage.Dataset);
        const userId = this.props.authData ? this.props.authData.userId : null;
        const authorization_value = "Basic " + base64.encode(userId + ":");

        let params = {
            siteId: dataset.siteId, toolId: dataset.toolId, startDate: startDate, endDate: endDate, selectedProperty: property, selectedPropertyValue: '', breakUp: breakup, includeBreakUp: include, excludeBreakUp: exclude, selectedMetric: metric,
            periodComparison: periodComparison, outputType: outputType, isInsight: true, summary: '', calculateGrowth: true, dashboard: true, type: 'summary', chart: 'Table', 'returnType': 'total'
        }
        CallAPI('GET', '/app/v1/trendChart', null, params, 0, function (response) {         
            let shortName = response.shortName    
            response = response.data;
            var resultCount = that.state.resultCount;
            var totalResult = that.state.totalResult;
            var finalResultLocal = that.state.finalResult;
            var shortNameLocal = that.state.shortName;
            var summary = null;
            summary = response == null ? -1 : response;   // Summary=-1 means there is some issue with the summary result
            resultCount = resultCount + 1;
            finalResultLocal[index] = summary;
            shortNameLocal[index] = shortName;
            //Set information that data for this component if loaded by its index
            var dataLoaded = that.state.dataLoaded;
            dataLoaded.push(index);
            if (that.state.runRateIndex == index || that.state.projectionIndex == index) {
                that.setState({
                    finalResult: finalResultLocal, resultCount: resultCount, totalResult: totalResult, shortName: shortNameLocal, 
                    dataLoaded: dataLoaded,
                    outputType: outputType
                });
            } else {
                that.setState({
                    finalResult: finalResultLocal, resultCount: resultCount, totalResult: totalResult, shortName: shortNameLocal,
                    dataLoaded: dataLoaded
                });
            }
        }, this.props.authData)

        /* Commented below axios api call & changed it to above CallAPI method */
        // axios.get("/app/v1/trendChart", {
        //     headers: { Authorization: authorization_value },
        //     params: {
        //         siteId: dataset.siteId, toolId: dataset.toolId, startDate: startDate, endDate: endDate, selectedProperty: property, selectedPropertyValue: '', breakUp: breakup, includeBreakUp: include, excludeBreakUp: exclude, selectedMetric: metric, 
        //         periodComparison: periodComparison, outputType: outputType, isInsight: true, summary: '', calculateGrowth: true, dashboard: true, type: 'summary', chart: 'Table', 'returnType': 'total'
        //     }
        // }).then(response => {
        //     response = response.data.data;
        //     var resultCount = that.state.resultCount;
        //     var totalResult = that.state.totalResult;
        //     var finalResultLocal = that.state.finalResult;
        //     var summary = null;
        //     summary = response == null ? -1 : response;   // Summary=-1 means there is some issue with the summary result
        //     resultCount = resultCount + 1;
        //     finalResultLocal[index] = summary;
        //     //Set information that data for this component if loaded by its index
        //     var dataLoaded = that.state.dataLoaded;
        //     dataLoaded.push(index);
        //     if (that.state.runRateIndex == index || that.state.projectionIndex == index) {
        //         that.setState({
        //             finalResult: finalResultLocal, resultCount: resultCount, totalResult: totalResult,
        //             dataLoaded: dataLoaded,
        //             outputType: outputType
        //         });
        //     } else {
        //         that.setState({
        //             finalResult: finalResultLocal, resultCount: resultCount, totalResult: totalResult,
        //             dataLoaded: dataLoaded
        //         });
        //     }

        // })
    }
    chart = (startDate, endDate, property, metric, breakup, include, exclude, sortOrder, limit, metricRange, chartType, period, reportTypeArray, index, periodComparison) => {        
        
        var that = this;
        var compareRank = this.state.rankToConsider['compareRank'] == index ? true : '';
        if (this.state.rankToConsider['trendCompare'] && this.state.rankToConsider['trendCompare'][this.state.trendCompareCounter] == index) {
            var trendCompareDates = this.state.trendCompareDates;
            startDate = trendCompareDates['startDate'];
            endDate = trendCompareDates['endDate'];
            var trendCompare = true;
        }
        trendCompare = false
        var chartTypeLower = chartType.toLowerCase();
        var chart = (chartTypeLower == 'column stacked' || chartTypeLower == 'column stack' || chartTypeLower == 'columnline' || chartTypeLower == 'barline') ? 'Line' : chartType;
        var analysis = false;
        var clusterCount = 0;
        // if (chartTypeLower == 'scatter' && insightTypeGlobal !== "deepInsight") {
        if (chartTypeLower == 'scatter') {
            // analysis = true;
            // analysis = 'quadrant';
            // clusterCount = 4;
        }

        metric = metric.split('|');
        var metricAbsoluteChange = metric[1];
        metric = metric[0];
        if (metricAbsoluteChange == 'Absolute Change') {
            // var fd = new FormData();
            var newData = {}
            newData.selectedProperty = property;
            newData.breakUp = breakup;
            newData.include = include;
            newData.exclude = exclude;
            newData.selectedMetric = metric;
            newData.sortOrder = "desc";
            newData.limit = 5;
            newData.type = 1;
            newData.startDate = startDate;
            newData.endDate = endDate;
            newData.periodComparison = "0";
            newData.returnType = "result";
            newData.actualProperty = null
            newData.dateGiven = true
            // fd.append('newData', JSON.stringify(newData));
            var DeepInsightFunction = encodeURIComponent('top 5');
            metricAbsoluteChange = encodeURIComponent(metricAbsoluteChange);
            urlList[index] = null;

            let params = { 'startDate': startDate, 'endDate': endDate, 'function': DeepInsightFunction, 'metric': metricAbsoluteChange, 'order': sortOrder, 'limit': limit, 'chart': chart, 'output': "", "use": "A", 'extendedFunction': 'growth', 'deepInsightDateAvailable': true, 'insightTemplate': true, 'isInsight': true }

            CallAPI('POST', '/dashboard/charttype/getchartabsolute', newData, params, 0, function (response) {
                checkIfSessionTimedOut(response)
                var resultCount = that.state.resultCount;
                var totalResult = that.state.totalResult;
                var chartData = null;
                if (response && response != 5 && response != 'Something went wrong!') {
                    chartData = response.insights;
                    resultCount = resultCount + 1;
                }
                var finalResultLocal = that.state.finalResult;
                finalResultLocal[index] = chartData;
                //Set information that data for this component if loaded by its index
                var dataLoaded = that.state.dataLoaded;
                dataLoaded.push(index);
                that.setState({
                    finalResult: finalResultLocal, resultCount: resultCount, totalResult: totalResult,
                    dataLoaded: dataLoaded
                });
            }, this.props.authData)

            /* Commented below jQuery.ajax api call & changed it to above CallAPI method */
            // jQuery.ajax({
            //     type: 'POST',
            //     data: fd,
            //     url: '/dashboard/charttype/getchartabsolute?startDate=' + startDate + "&endDate=" + endDate + "&function=" + DeepInsightFunction + "&metric=" + metricAbsoluteChange + "&order=" + sortOrder + "&limit=" + limit + "&chart=" + chart + "&output=" + "&use='A'" + "&extendedFunction='growth'" + "&deepInsightDateAvailable=true" + "&insightTemplate=true" + '&isInsight=true',
            //     contentType: false,
            //     processData: false,
            //     success: function (response) {
            //         checkIfSessionTimedOut(response)
            //         var resultCount = that.state.resultCount;
            //         var totalResult = that.state.totalResult;
            //         var chartData = null;
            //         if (response && response != 5 && response != 'Something went wrong!') {
            //             chartData = response.insights;
            //             resultCount = resultCount + 1;
            //         }
            //         var finalResultLocal = that.state.finalResult;
            //         finalResultLocal[index] = chartData;
            //         //Set information that data for this component if loaded by its index
            //         var dataLoaded = that.state.dataLoaded;
            //         dataLoaded.push(index);
            //         that.setState({
            //             finalResult: finalResultLocal, resultCount: resultCount, totalResult: totalResult,
            //             dataLoaded: dataLoaded
            //         });
            //     }
            // });
        } else {
            property = refineURLData(property) ? property : null;
            var pathName = '/chart/chartData'
            var apiName = '/app/trendChart'
            if (chartTypeLower == 'table') {
                var finalResultLocal = that.state.finalResult;
                finalResultLocal[index] = '1';
                var dataLoaded = that.state.dataLoaded;
                dataLoaded.push(index);
                var resultCount = that.state.resultCount;
                resultCount++;
                let transpose = reportTypeArray == 'transpose' ? true : null
                let multiDim = reportTypeArray == 'crosstab' ? false : true
                urlList[index] = '/report' + '?property=' + property + '&metric=' + metric + '&startDate=' + startDate + '&endDate=' + endDate + '&chartCat=report&period=' + period + '&breakup=' + breakup + '&include=' + include + '&exclude=' + exclude + '&metricRange=' + metricRange + '&range=' + metricRange + `&multiDim=${encodeURIComponent(multiDim)}&transpose=${encodeURIComponent(transpose)}`;
                that.setState({ finalResult: finalResultLocal, resultCount: resultCount, dataLoaded: dataLoaded });
                return;
            }
            period = period ? period : 'aggregate'
            urlList[index] = `${pathName}` + '?chartCat=' + chartType + '&property=' + property + '&propertyValues=&breakup=' + breakup + '&include=' + include + '&exclude=' + exclude + '&metric=' + metric + '&startDate=' + startDate + '&endDate=' + endDate + '&chartType=' + period + '&period=' + period + '&sortOrder=' + sortOrder + '&limit=' + limit + '&metricRange=' + metricRange + + '&range=' + metricRange + '&analysis=' + analysis + '&regressionLine=false&clusterCount=' + clusterCount + '&drill=null&insightType=&insightMetric=&compare=' + trendCompare + '&dataMover=&compareRank=' + compareRank + '&isInsight=true&periodComparison=' + periodComparison;

            if (that.state.rankToConsider['trendCompare'] && that.state.rankToConsider['trendCompare'][that.state.trendCompareCounter] == index) {
                var trendCompareCounter = that.state.trendCompareCounter;
                trendCompareCounter++;
                that.setState({
                    trendCompareCounter: trendCompareCounter
                });
            }

            var dataset = JSON.parse(localStorage.Dataset);
            const userId = this.props.authData ? this.props.authData.userId : null;
            const authorization_value = "Basic " + base64.encode(userId + ":");

            let params = {
                siteId: dataset.siteId, toolId: dataset.toolId,
                startDate: startDate, endDate: endDate, selectedProperty: property, breakUp: breakup, includeBreakUp: include, excludeBreakUp: exclude, selectedMetric: metric, period: period, chart: chart, analysis: analysis, clusterCount: clusterCount, chartDisp: chartType, sortOrder: sortOrder, limit: limit, compareRank: compareRank, compare: trendCompare, isInsight: true, dashboard: true, test: true, periodComparison: periodComparison, range: metricRange
            }

            CallAPI('GET', apiName, null, params, 0, function (response) {
                
                let dataInformation = response.information;
                var resultCount = that.state.resultCount;
                var totalResult = that.state.totalResult;
                var chartData = null;
                if (response && response != 5 && response != 'Something went wrong!') {
                    chartData = response;
                    resultCount = resultCount + 1;
                } else {
                    chartData = -1; // Something went wrong!
                }
                var finalResultLocal = that.state.finalResult;
                finalResultLocal[index] = chartData;
                //Set information that data for this component if loaded by its index
                var dataLoaded = that.state.dataLoaded;
                dataLoaded.push(index);
                let information = that.state.information
                if (information != undefined) {
                    information[index] = dataInformation
                }
                that.setState({
                    finalResult: finalResultLocal, resultCount: resultCount, totalResult: totalResult,
                    dataLoaded: dataLoaded,
                    information: information
                })
            }, this.props.authData)

            /* Commented below axios api call & changed it to above CallAPI method */
            // axios.get(apiName, {
            //     type: 'get',
            //     async: true,
            //     headers: { Authorization: authorization_value },
            //     params: {
            //         siteId: dataset.siteId, toolId: dataset.toolId,
            //         startDate: startDate, endDate: endDate, selectedProperty: property, selectedPropertyValue: "", breakUp: breakup, include: include, exclude: exclude, selectedMetric: metric, period: period, chart: chart, analysis: analysis, clusterCount: clusterCount, drill: "", chartDisp: chartType, sortOrder: sortOrder, limit: limit, compareRank: compareRank, compare: trendCompare, isInsight: true, dashboard: true, test: true, periodComparison: periodComparison
            //     }
            // }).then(response => {
            //     response = response.data;
            //     let dataInformation = response.information;
            //     var resultCount = that.state.resultCount;
            //     var totalResult = that.state.totalResult;
            //     var chartData = null;
            //     if (response && response != 5 && response != 'Something went wrong!') {
            //         chartData = response;
            //         resultCount = resultCount + 1;
            //     } else {
            //         chartData = -1; // Something went wrong!
            //     }
            //     var finalResultLocal = that.state.finalResult;
            //     finalResultLocal[index] = chartData;
            //     //Set information that data for this component if loaded by its index
            //     var dataLoaded = that.state.dataLoaded;
            //     dataLoaded.push(index);
            //     let information = that.state.information
            //     information[index] = dataInformation
            //     that.setState({
            //         finalResult: finalResultLocal, resultCount: resultCount, totalResult: totalResult,
            //         dataLoaded: dataLoaded,
            //         information: information
            //     });
            // })
        }
    }
    arePrevAndNextPropsEqual = (prevProps, nextProps) => {
        if (nextProps.insightType != "deepInsight") {
            if (prevProps.breakup == nextProps.breakup && prevProps.date == nextProps.date && prevProps.endDate == nextProps.endDate && prevProps.startDate == nextProps.startDate && prevProps.insightEnable == nextProps.insightEnable && prevProps.metric == nextProps.metric && prevProps.period == nextProps.period && prevProps.point == nextProps.point && prevProps.property == nextProps.property && prevProps.insightMetric == nextProps.insightMetric && prevProps.pointMetric == nextProps.pointMetric)
                return true;
            else return false;
        } else {
            if (prevProps.property == nextProps.property && prevProps.breakup == nextProps.breakup && prevProps.include == nextProps.include && prevProps.exclude == nextProps.exclude && prevProps.metric == nextProps.metric && prevProps.startDate == nextProps.startDate && prevProps.endDate == nextProps.endDate && prevProps.limit == nextProps.limit && prevProps.sortOrder == nextProps.sortOrder && prevProps.insightMetric == nextProps.insightMetric && prevProps.pointMetric == nextProps.pointMetric && prevProps.point == nextProps.point && prevProps.date == nextProps.date)
                return true;
            else return false;
        }
    }
    closeSidebarInsight = () => {
        var temp_url = location.pathname.split('/');
        temp_url = temp_url[temp_url.length - 1];
        
        this.props.setInsightFunction({"point": null, "insight": false});
    }
    openComment = (type, e) => {
        var id = jQuery(e.target).parent().parent().parent().parent().attr('id');
        var likeId = '#' + id + 'Like';
        var dislikeId = '#' + id + 'Dislike';
        //convert color to rgb to hex
        var likeColor = rgb2hex(jQuery(likeId).css('color'));
        var dislikeColor = rgb2hex(jQuery(dislikeId).css('color'));
        dislikeColor = (dislikeColor == '#222222' || dislikeColor == '#000000')
            ? '#222222'
            : '#ff0000';
        likeColor = (likeColor == '#222222' || likeColor == '#000000')
            ? '#222222'
            : '#ff0000';
        // #ff0000 : red, #222222 or #000000 : black
        if (type === 'like') {
            jQuery('#hiddenResponse').val('Like');
            if (likeColor == '#222222' && dislikeColor == '#222222')
                jQuery(likeId).css('color', 'red');
            else if (likeColor == '#ff0000' && dislikeColor == '#222222')
                jQuery(likeId).css('color', 'black');
            else if (likeColor == '#222222' && dislikeColor == '#ff0000') {
                jQuery(likeId).css('color', 'red');
                jQuery(dislikeId).css('color', 'black');
            }
        } else {
            jQuery('#hiddenResponse').val('DisLike');
            if (likeColor == '#222222' && dislikeColor == '#222222')
                jQuery(dislikeId).css('color', 'red');
            else if (likeColor == '#222222' && dislikeColor == '#ff0000')
                jQuery(dislikeId).css('color', 'black');
            else if (likeColor == '#ff0000' && dislikeColor == '#222222') {
                jQuery(dislikeId).css('color', 'red');
                jQuery(likeId).css('color', 'black');
            }
        }
    }
    InsightOpenInNewTab = (that) => {  
        var parameters = {};
        let property = this.state.insightProperty ? this.state.insightProperty : this.state.property 
                
        let breakup = this.state.insightBreakup ? this.state.insightBreakup : this.state.breakup 
        let include = this.state.insightInclude ? this.state.insightInclude : this.state.include 
        let exclude = this.state.insightExclude ? this.state.insightExclude : this.state.exclude 
        let startDate = this.state.insightStartDate ? this.state.insightStartDate : this.state.startDate 
        let endDate = this.state.insightEndDate ? this.state.insightEndDate : this.state.endDate 
        // let startDate = this.state.startDate 
        // let endDate = this.state.endDate 
        let period = this.state.insightPeriod ? this.state.insightPeriod : this.state.period 
        let chartCat = this.state.insightChart ? this.state.insightChart : this.state.chartCat
        let point = this.props.point
        if(this.props.point && !(this.props.point.split(';')[1])) {
            if(property && (property.split(';')[1])) {
                point = point.concat(';', property) 
            } 
        }
        chartCat = chartCat ? chartCat : this.state.chart 
        parameters['property'] = encodeURIComponent(property ? property : getParameters('property'));
        parameters['propertyValues'] = "";
        // parameters['breakup'] = encodeURIComponent(this.state.breakupArray.filter((x, i, a) => x && a.indexOf(x) == i).join(','))
        // Commented above line as it was taking the breakup including point which was causing to take wrong template when open in new tab
        parameters['breakup'] = encodeURIComponent(breakup)
        parameters['include'] = encodeURIComponent(refineURLData(include))
        parameters['exclude'] = encodeURIComponent(refineURLData(exclude))
        parameters['metric'] = encodeURIComponent(this.props.metric ? this.props.metric : (this.props.pointMetric ? this.props.pointMetric : getParameters('metric')));
        parameters['startDate'] = encodeURIComponent(startDate);
        parameters['endDate'] = encodeURIComponent(endDate);
        parameters['question'] = "";
        parameters['insightPoint'] = parameters['point'] = encodeURIComponent(point);        
        parameters['insightDate'] = encodeURIComponent(this.state.date);
        parameters['chartCat'] = encodeURIComponent(chartCat ? chartCat : getParameters('chartCat'));
        parameters['period'] = encodeURIComponent(period ? period : getParameters('period'));
        var url = JSON.stringify(parameters);
        url = url.replace(/{/g, "");
        url = url.replace(/}/g, "");
        url = url.replace(/:/g, "=")
        url = url.replace(/",/g, "&");
        url = url.replace(/"/g, "");
        
        console.log(url)
        var win = null;
        if (this.props.insightType === "insight") {
            win = window.open("/insight?" + url, '_blank')
        } else win = window.open("/deepinsight?" + url, '_blank');
        win.focus();
    }
    saveComment = () => {
        saveComment();
    }
    openComment(type, e) {
        openComment(type, e);
    }
    render() {
        var that = this
        var newPage = this.state.newPage;
        var finalResult = this.state.finalResult;
        var shortName = this.state.shortName;
        var storeComponent = [];
        var hr = <hr className='col-md-12 hr' style={{ marginTop: '0px' }} />;
        var resultCount = this.state.resultCount;
        var dataLoaded = this.state.dataLoaded;
        var dataToDisplay = null;
        if (dataLoaded == -1) {  // Case for Deep Insight when there is not spike/dip
            if (this.state.sortOrder == 'asc')
                dataToDisplay = 'Congratulation! No dip detected.';
            else if (this.state.sortOrder == 'desc')
                dataToDisplay = 'Sorry! No spike detected.';
            dataToDisplay = <h2 style={{ textAlign: 'center', marginTop: '7%' }}>{dataToDisplay}</h2>;
        } else if (dataLoaded == -2) {   // No date range specified by user
            dataToDisplay = 'Please specify the correct date period to get Spike/Dip Analysis';
            dataToDisplay = <h2 style={{ textAlign: 'center', marginTop: '7%' }}>{dataToDisplay}</h2>;
        } else if (dataLoaded == -3) {   // Case when Insight rules come null in Auto Analysis
            dataToDisplay = 'Oops! Something went wrong.';
            dataToDisplay = <h2 style={{ textAlign: 'center', marginTop: '7%' }}>{dataToDisplay}</h2>;
        } else {
            
            if (dataLoaded.length > 0) {
                var compResult = null;
                // calculate total length
                var totalResult = this.state.totalResult ? this.state.totalResult : this.state.chartType.length;
                dataLoaded = dataLoaded.sort(function (a, b) { return a - b });
                var sequenceLoaded = getSequenceBreakPoint(dataLoaded, this.state.type);
                var runRateIndex = this.state.runRateIndex;
                var projectionIndex = this.state.projectionIndex;
                var outputType = '';
                var hideChart = '';
                let propertyArray = this.state.propertyArray;
                let breakupArray = this.state.breakupArray;
                let include = this.state.include
                let exclude = this.state.exclude
                let resultCompare = false;
                let period = null
                
                var dashboard_config = this.props.dashboard_config
                dashboard_config['colorArray'] = typeof this.props.dashboard_config['colorArray'] == "string" ? JSON.parse(this.props.dashboard_config['colorArray']) : this.props.dashboard_config['colorArray'];
                dashboard_config['colorArray'] = dashboard_config['colorArray'] && dashboard_config['colorArray'].length>0 ? dashboard_config['colorArray'] : JSON.parse(this.props.dataSet.userDBSetting[0].color);

                //Load all the components with highest number in unbroken sequence for all the components loaded
                for (var index = 0; index <= sequenceLoaded; index++) {
                    var boxId = 'box' + index;
                    var boxIdDislikeId = 'box' + index + 'Dislike'; var boxIdLikeId = 'box' + index + 'Like';
                    compResult = null;
                    var result = finalResult[index];
                    let summaryShortName = shortName[index]
                    if (result == -1)    // Skip the output for which there is an error
                        continue;
                    if (result) {
                        var id = result['id'];
                        var finalSummaryResult = null
                        //Check compoenent type
                        if (this.state.chartType[index] == 'Summary') { 
                            let metricDataTemp = getMetricData(this.state.metric[index].split(','), metricGlobal, metricFunction)
                            var date = result.date;
                            result = result.result;
                            var metric = '';
                            if (runRateIndex == index || projectionIndex == index) {
                                var metricData = metric = result.metric;
                                hideChart = true;
                                if (runRateIndex == index)
                                    outputType = 'runrate;1';
                                else if (projectionIndex == index)
                                    outputType = 'projection';
                            } else {
                                // var growthStartDate = date.startDate;
                                // var growthEndDate = date.endDate;
                                var growthStartDate = null;
                                var growthEndDate = null;
                                finalSummaryResult = result
                                if(insightTypeGlobal == "deepInsight") {
                                    metric = this.state.metric[index];
                                    // finalSummaryResult = result
                                    var metricData = metric.split(',');
                                } else {
                                    // finalSummaryResult = result[0] ? result[0] : result;
                                    var metricData = finalSummaryResult ? [finalSummaryResult.description] : []; 
                                }                                
                            }
                            
                            let metricLength = metricData.length
                                for(let summaryIndex=0; summaryIndex<metricLength; summaryIndex++) {                                    
                                    result = finalSummaryResult[summaryIndex]
                                    metric = result ? result.description : null
                                    metricData = metric ? refineData(metric, metricGlobal, metricFunction) : null
                                    if(metricData){
                                        var metricUnit = metricData['metricUnit'];
                                        var metricPrefix = metricData['metricPrefix'];
                                        var newDataFull = number_shorten(result.data, metricData['roundOff'], metricData['numberShorten']);
                                        if (newDataFull) {
                                            if (metricPrefix == 'true') {
                                                if (metricUnit == 'INR.') {
                                                    newDataFull = <span><span>&#x20B9;</span><span> {newDataFull}</span></span>;
                                                }
                                            } else {
                                                newDataFull = metricUnit ? (newDataFull + ' ' + metricUnit) : newDataFull;
                                            }
                                        }
                                        var mainValue = newDataFull ? delimitNumbersIndianFormat(result.data) : null;

                                        var spikeStyle = 2;
                                        var insightStyle = true;
                                        if (newPage) {
                                            spikeStyle = true;
                                            insightStyle = 2;
                                        }

                                        var data = [];
                                        data['data'] = result.data;                                     
                                        data['metric'] = metric;
                                        data['metricData'] = metricDataTemp[metric]
                                        // data['description'] = result.description;
                                        // data['growth'] = result.growth;
                                        // data['absolute'] = result.absolute;
                                        // data['previous_value'] = result.previous_value;
                                        data['allData'] = result;
                                        compResult = <SummaryMessage
                                            data={data}
                                            key={index}
                                            id={"sidebar_" + index}
                                            hideGrowth={true}
                                            insightStyle={insightStyle}
                                            // spikeNewPageStyle={spikeStyle}
                                            growthStartDate={growthStartDate}
                                            growthEndDate={growthEndDate}
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            outputType={outputType}
                                            hideChart={hideChart}
                                            periodComparison="0"
                                            metricGlobal={metricGlobal}
                                            metricFunction={metricFunction}
                                            property={propertyArray ? propertyArray[index] : null}
                                            breakup={breakupArray ? breakupArray[index] : null}
                                            include={include}
                                            exclude={exclude}
                                            insightSummary={true}
                                            summaryShortName={summaryShortName}
                                            // drillHandle={drillHandleFunction}
                                        />
                                        storeComponent.push(compResult);
                                }                            
                            }
                        } else {                            
                            //isSideInsight is used to refresh chart when every new charts gets loaded
                            // if (this.state.insightType == "deepInsight") {
                            if (this.state.callType && this.state.callType[index] !== 'direct' && insightTypeGlobal == "deepInsight") {
                                resultCompare = false;
                                period = null
                                var colId1 = 'col-md-9';
                                var openInNewTab = null;
                                result = result.insights ? result.insights : result;
                                if (!(result.data))  // When there is no trend is applicable in deep insight
                                    continue;
                                var feedbackDislikeId = 'DeepInsight_' + id + '_Dislike';
                                var feedbackLikeId = 'DeepInsight_' + id + '_Like';
                                var color = colors[Math.floor(index % colors.length)];
                                var tempIndex = index + 2;
                                var deepIndex = index;
                                var selectedMetric = result['metric'];
                                var header = result.insightHeader;
                                var description = result.insightDescription;
                                var category = this.state.allProperty[deepIndex]
                                if (description) {                                    
                                    var descriptionData = <div>
                                        <div className='row todo-list'>
                                            {/* <div className='col-md-11' style={{ marginTop: '-0.5%', width: '100%', marginBottom: '-2%' }}> */}
                                            <div className='col-md-12'>
                                                <div className='box'>
                                                    <div className='box-content box-no-padding' style={{ border: 'none' }}>
                                                        <div className='sortable-container'>
                                                            <ul
                                                                className="list-unstyled sortable ui-sortable"
                                                                data-sortable-axis="y"
                                                                data-sortable-connect=".sortable">
                                                                <li className="important item ui-sortable-handle" style={{ lineHeight: '20px', cursor: 'auto', background: 'rgba(247, 247, 247, 0.26)', marginTop: '5px', borderTop: '1px solid #dddddd', borderBottom: '1px solid #dddddd', borderRight: '1px solid #dddddd', borderLeft: "2px solid " + color }}>
                                                                    <label className="check pull-left todo" style={descriptionLabelStyle}>
                                                                        <div className="col-md-12 chartsInfo">{description}</div>
                                                                    </label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>;
                                } else {
                                    var descriptionData = null;
                                }
                            } else {
                                if(result && result.parameter_cache) {
                                    period = result.parameter_cache.period
                                    resultCompare = result.parameter_cache.compare;
                                }                                
                                var feedbackDislikeId = 'InsightChart_' + id + '_Dislike';
                                var feedbackLikeId = 'InsightChart_' + id + '_Like';
                                var tempIndex = insightTypeGlobal == "deepInsight" ? index + 2 : index + 1;
                                var deepIndex = index;
                                var header = this.state.header ? this.state.header[index] : '';
                                header = header ? header : generateHeader(this.state.information[index]);
                                if (insightTypeGlobal == "deepInsight") {
                                    if (!header) { 
                                        let paramsToUse = []
                                        let rule = this.state.function[index] + '_' + this.state.extendedFunction[index]
                                        paramsToUse.push({'key': 'PROPERTY', 'value': result.information && result.information.property ? result.information.property : result['parameter_cache']['category']['property']})
                                        let orderToUse = result.information && result.information.sortOrder ? result.information.sortOrder  : result['parameter_cache']['sort']['sortOrder']                                    
                                        paramsToUse.push({'key': 'ORDER', 'value': orderToUse == 'asc' ? 'Bottom' : 'Top'})
                                        paramsToUse.push({'key': 'PERIOD', 'value': result.information && result.information.period ? result.information.period : result['parameter_cache']['period'] && result['parameter_cache']['period']!='aggregate' ? result['parameter_cache']['period'] : ''})
                                        let metricValueToUseTemp = result['parameter_cache']['selectedMetric'].split(',')[0]
                                        let metricToUse = result.data && result.data.yAxis ? result.data.yAxis.title ? result.data.yAxis.title.text : result.data.yAxis[0].title.text : null
                                        let metricText = null
                                        if (result.information && result.information['metric']) {
                                            let metricData = result.information['metric']
                                            let metricCount = metricData.length;
                                            metricData.forEach(function(data, metIndex) {
                                                if (metIndex != 0) {
                                                    if (metIndex == metricCount - 1)
                                                        metricText += ' and ' + data;
                                                    else metricText += ', ' + data;
                                                } else metricText = data;
                                            });
                                        }                                    
                                        metricToUse = metricText ? metricText : metricToUse
                                        paramsToUse.push({'key': 'METRIC', 'value': metricToUse ? metricToUse : result['shortNameKPI'] ? result['shortNameKPI'][metricValueToUseTemp] : metricValueToUseTemp})
                                    
                                        let headerData = generateHeaderAndDescriptionDeepInsight(this.state.headingRules[this.state.function[index]], this.state.descriptionRules[rule], paramsToUse)
                                        header = headerData[0]['value']
                                    }                                    
                                }                                
                                var descriptionData = null;
                                var selectedMetric = this.state.metric[deepIndex];
                                var category = this.state.propertyArray ? this.state.propertyArray : this.state.allProperty
                                category = category[deepIndex]
                                var colId1 = 'col-md-9';
                                //marginRight: "12px",
                                var openInNewTab = <a target="_blank" href={urlList[index]} style={{ marginLeft: "10px", marginTop: '-2px', padding: '0px' }} className="pull-right" data-toggle="tooltip" title="Open in New Tab" data-placement="bottom"><i className='fa fa-external-link openInNewTab' style={{ fontSize: 'initial', color: 'black' }}></i></a>;
                            }
                            
                            var dashboard_config = setDashboardConfigFromJson(category, selectedMetric, period, this.state.chartType[deepIndex], this.props.dashboard_config, this.props.dataSet.userDBSetting[0].color)['dashboard_config'];
                            if (resultCompare == "true") {
                                var final_metric = selectedMetric;
                                var final_metric_array = [];
                                final_metric.split(",").map(function (innerData, index) {
                                    var temp = refineData(innerData, metricGlobal, metricFunction);
                                    if (temp.previousValue == "1")
                                        final_metric_array.push(temp.value);
                                    final_metric_array.push(temp.value);
                                });
                                final_metric = final_metric_array.join();
                            }

                            let reportIndex = index+'1'   
                            
                            var chartData = null;
                        
                            if(this.state.params) {
                                let reportType = this.state.params['reportTypeArray'] ? this.state.params['reportTypeArray'][index] : null
                                
                                var chartData = 
                                <TableData
                                    authData={this.props.authData}                                        
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    category={this.state.params['property'][index]}
                                    selectedMetric={this.state.params['metric'][index]}
                                    breakUp={this.state.params['breakup'] ? this.state.params['breakup'][index] : null}
                                    include={this.state.params['includeBreakUp'] ? this.state.params['includeBreakUp'][index] : include}
                                    exclude={this.state.params['excludeBreakUp'] ? this.state.params['excludeBreakUp'][index] : exclude}
                                    metrics={metricGlobal}
                                    drill={null}
                                    drillHandle={null}
                                    question={null}
                                    questionId={null}
                                    questionData={null}
                                    sortOrder={this.state.params['sortOrder'] ? this.state.params['sortOrder'][index] : null}
                                    limit={this.state.params['limit'] ? this.state.params['limit'][index] : null}
                                    insightType={null}
                                    insightMetric={null}
                                    insightPoint={null}
                                    handleChange={null}
                                    index={reportIndex}
                                    // calendarStatus={calendar}
                                    calendarStatus={false}
                                    selectedMetricDisp={[]}
                                    metricRange={null}
                                    metricText={null}
                                    propertyText={null}
                                    propertyDisp={[]}
                                    breakupText={null}
                                    includeText={null}
                                    excludeText={null}
                                    period={this.state.params['period'] ? this.state.params['period'][index] : ''}
                                    transpose={reportType == 'transpose' ? true : null}
                                    multiDim={reportType == 'crosstab' ? false : true}
                                    multiDimGroup={null}
                                    shortenHandle={true}
                                    dashboard={"insight"}
                                    dashboard_config={[]}
                                />
                            }
                            period = period ? period : 'aggregate'
                            let isValidChartData = (result && result['data'] && result['data']['series'] && result['data']['series'][0] && result['data']['series'][0]['data'] && (result['data']['series'][0]['data'][0] || result['data']['series'][0]['data'][0] === 0))
                            if (newPage) {
                                var className = 'pull-right';
                                if(this.state.chartType[index] != 'Table') {
                                    if (isValidChartData) {
                                        chartData = <ChartComponent data={result} category={category} selectedMetric={selectedMetric} metricFunction ={metricFunction} selectedMetric_new={final_metric} chartCat={this.state.chartType[deepIndex]} index={tempIndex} mainMetric={metricGlobal} isSideInsight={true} compare={resultCompare}  period={period}
                                        dashboard_config={dashboard_config} contextMenu={false}
                                        />;
                                    } else {
                                        continue;
                                    }
                                }                                
                                //spikeNewPageStyle={true}
                            } else {
                                var className = '';
                                if(this.state.chartType[index] != 'Table') {
                                    if (isValidChartData) {
                                        chartData = <ChartComponent data={result} category={category} selectedMetric={selectedMetric}
                                        metricFunction ={metricFunction} selectedMetric_new={final_metric} chartCat={this.state.chartType[deepIndex]} index={tempIndex} spikeStyle={true}  mainMetric={metricGlobal} isSideInsight={true} compare={resultCompare} period={period}
                                        dashboard_config={dashboard_config}
                                        />;
                                    } else {
                                        continue;
                                    }
                                }                                
                                // var chartData = <ChartComponent data={result} selectedMetric={this.state.metric[index]} chartCat={this.state.chartType[index]} index={index}  />;
                                // compResult = 
                                // <div>
                                //     <div style={{ marginBottom: '15%'}}>
                                //         <div style={insightMargin}>{this.state.header[index]}</div>
                                //         <div>{chartData}</div>
                                //     </div>
                                //     {hr}
                                // </div>;                        
                            }
                            let linkCollaspeId = 'collaspe' + index;
                            let accordionExample = 'accordionExample' + index;
                            var boxpadding = newPage?"col-md-12":null;
                            let accordionBoxPadding = newPage ? 'col-md-6' : null
                            let currentUrl = urlList && urlList[index] ? urlList[index] : null
                            let openUrlStyle = currentUrl ? 'show' : 'none';
                            compResult= <div className={boxpadding+" accordion"} id={accordionExample} style={{padding: '0px', }}>
                                            <div className={boxpadding+" card mg-b-15"}>
                                                <div className='card-header pd-10'  id={boxId} style={{padding:'0px',cursor:'pointer',marginBottom:'0px'}}>
                                                    <button className="btn btn-link" type="button" style={{textAlign:'left', paddingRight:'25px', whiteSpace: 'normal', width:"95%"}}><span className="tx-color-02 mg-b-8">{header}</span></button>
                                                    <div className="d-md-flex">
                                                        <div className="dropdown-file">
                                                            <i className="customIcon fas fa-angle-right rotate-icon"  data-bs-toggle="collapse" data-bs-target={`#${linkCollaspeId}`} aria-expanded="true" aria-controls={linkCollaspeId} style={{paddingRight:'20px'}}></i>
                                                            <a href="" className="dropdown dropdown-link" data-bs-toggle="dropdown" style={{display:openUrlStyle}}><i aria-expanded="false" className=" desc-btn fas fa-ellipsis-v mg-r-10"></i></a>
                                                            <div className="dropdown-menu dropdown-menu-end">
                                                                <a className="dropdown-item" target="_blank" href={currentUrl}><i className='fas fa-external-link-alt' style={{marginRight: "5px", fontSize: '14px'}}></i>{" Open in new tab"}</a>
                                                                <a className="dropdown-item" onClick={this.openComment.bind(this, 'like')} id={feedbackLikeId}>
                                                                    <i className='far fa-thumbs-up' style={likeDislikeMargin}></i>{" Like"}
                                                                </a>
                                                                <a className="dropdown-item" onClick={this.openComment.bind(this, 'disLike')} id={feedbackDislikeId}>
                                                                    <i className='far fa-thumbs-down' style={likeDislikeMargin}></i>{" Dislike"}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id={linkCollaspeId} className="collapse show" aria-labelledby={boxId} data-bs-parent={`#${accordionExample}`}>{chartData}</div>
                                                {descriptionData}
                                            </div>
                                        </div>
                            storeComponent.push(compResult);
                        }
                    } else {
                        //Do nothing
                        // storeComponent.push(<NoDataFound />);
                    }
                }
                //Show loading component till all the components are loaded
                if (sequenceLoaded < totalResult - 1) {
                    storeComponent.push(<div id={"box" + sequenceLoaded + 1} key={"loading_component"} className="box col-md-12 box-solid box-success"><LoadingComponent /></div>);
                }
                var displayDate = 'Selected Period: ' + this.state.displayDate;
                displayDate = newPage ? <span>{displayDate}</span> : <span>{displayDate}</span>;
                // var compareDate = newPage ? <div>{this.state.compareDate}</div> : '';
                var compareDate = <div>{this.state.compareDate}</div>;
                if (this.state.breakupToShow && this.state.breakupToShow != ' ()') {
                    var breakupToShow = 'Filter by: ' + this.state.breakupToShow;
                    breakupToShow = newPage ? <div>{breakupToShow}</div> : <div>{breakupToShow}</div>;
                } else {
                    var breakupToShow = '';
                }
                if(this.state.includeToShow) {
                    var includeToShow = this.state.includeToShow;
                    includeToShow = newPage ? <div>{includeToShow}</div> : <div>{includeToShow}</div>;
                } else {
                    var includeToShow = '';
                }
                if(this.state.excludeToShow) {
                    var excludeToShow = this.state.excludeToShow;
                    excludeToShow = newPage ? <div>{excludeToShow}</div> : <div>{excludeToShow}</div>;
                } else {
                    var excludeToShow = '';
                }
                var styleCenterAlignCSS = newPage ? "row box col-md-12 pd-x-0" : "box col-md-12";
                // var dateTimeAlign = newPage ? { textAlign: "right", margin: "0px auto", paddingRight: '30px', float: "none" } : { textAlign: "left", margin: "0px auto" };
                var dateTimeAlign = newPage ? { textAlign: "left", margin: "0px auto", float: "none" } : { textAlign: "left", margin: "0px auto" };
                var padding = jQuery(window).width() < mobile_width ? { float: "none", margin: "0px auto", padding: '0px' } : { float: "none", margin: "0px auto" };
                // console.log()
                dataToDisplay = <div>
                    <div className={`col-md-12 pd-y-20 ${this.props.newPage == true ? 'pd-x-0' : 'pd-l-15'}`} style={dateTimeAlign}>
                        {displayDate}
                        {compareDate}
                        {breakupToShow}
                        {includeToShow}
                        {excludeToShow}
                    </div>
                    <div className={styleCenterAlignCSS} style={padding}>
                        {/* {storeComponent.map(function(data, index){return <span key={"index"+index}>{data}</span>})} */}
                        {storeComponent.map(function (data, index) { return data })}
                    </div>
                </div>;
            } else {
                //When the first component is not loaded yet
                dataToDisplay = <LoadingComponent />;
            }
        }
        let title = insightTypeGlobal != "deepInsight" ? "Insight " : "Root Cause " 
        var displayResult = null;
        if (newPage) {
            displayResult = <div id='SidebarFullDiv' className="col-md-12 pd-x-0">
                {dataToDisplay}
            </div>
        } else {
            displayResult = <div className='sidebar sidebar-fixed insight-formatting' id='SidebarInsightDiv'>
                <div className='card-header tx-16 pd-10'>
                    {title}
                    <i title='Open In New Tab' onClick={this.InsightOpenInNewTab.bind(that)} className='fas fa-external-link-alt' data-toggle="tooltip" data-placement="bottom"></i>
                    <a href="javascript:void(0)" id="insightBar" className="close float-right" onClick={this.closeSidebarInsight}>&times;</a>
                </div>
                <div className="insight-overflow">
                    {dataToDisplay}
                </div>
            </div>
        }
        return (displayResult)
    }
};

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
//Gets the highest number for which number sequence is unbroken
//Used to not load chart in sequence
function getSequenceBreakPoint(numArray, type) {
    // if(insightType!="deepInsight") {
    var breakPoint = -1;
    for (var i = 0; i <= 32; i++) {
        if (numArray[i] == i) {
            breakPoint = i;
        } else {
            return breakPoint;
        }
    }
    // } else {
    //     var breakPoint=0;        // when above i from 1 
    //     for(var i=1;i<=32;i++)   
    //     {    
    //        if(numArray[i-1] != i){
    //            return breakPoint;
    //        } else {
    //            breakPoint=numArray[i-1];
    //        }
    //     }
    // }
}

function mapStateToProps(state) { 
    let newPage = window.location.pathname.split("/")[window.location.pathname.split("/").length-1];
    let insightType = 'insight'; 
    if(newPage == "deepinsight" || newPage == "insight") {        
        insightType = newPage == 'deepinsight' ? 'deepInsight' : 'insight'
        newPage = true
    } else {
        insightType = state.dataSet.deepInsight ? 'deepInsight' : 'insight'
        newPage = false
    }    
    insightTypeGlobal = insightType
    let dashboardConfig = state.dataSet.dashboardConfig ? state.dataSet.dashboardConfig : {"legend":true,"gridline":false,"x_axis":true,"y_axis":true,"x_axis_label":true,"y_axis_label":true,"data_labels":true,"information":true, "colorArray" : null};
    
    metricGlobal = state.dataSet.metricGlobal; metricFunction = state.dataSet.metricFunction;
    
    let returnConfig = {        
        authData: state.dataSet.authData,
        dataSet: state.dataSet.dataSet,
        breakup: state.dataSet.breakup,
        breakupDisp: state.dataSet.breakupDisp,
        insightDate: state.dataSet.insightDate,
        startDate: state.dataSet.startDate,
        endDate: state.dataSet.endDate,
        mainMetric: state.dataSet.metricGlobal,
        insightMetric: state.dataSet.insightMetric,
        pointMetric: state.dataSet.pointMetric,
        insightSortOrder: state.dataSet.insightSortOrder,
        period: state.dataSet.period,
        sortOrder: state.dataSet.sortOrder,
        limit: state.dataSet.limit,
        dashboard_config: dashboardConfig,        
        newPage: newPage,
        insightType: insightType        
    }
    
    if(newPage) {
        let url = window.location.search;
        let property = refineURLData(getParametersFromString('property', url))
        let metric = refineURLData(getParametersFromString('metric', url))
        let breakup = refineURLData(getParametersFromString('breakup', url))
        let startDate = refineURLData(getParametersFromString('startDate', url))
        let endDate = refineURLData(getParametersFromString('endDate', url))
        let include = refineURLData(getParametersFromString('include', url))
        let exclude = refineURLData(getParametersFromString('exclude', url))
        let period = refineURLData(getParametersFromString('period', url))
        let insightPoint = refineURLData(getParametersFromString('insightPoint', url))
        let insightDate = refineURLData(getParametersFromString('insightDate', url))
        let chartCat = refineURLData(getParametersFromString('chartCat', url))
        // returnConfig['property'] = property ? property : state.dataSet.property
        // returnConfig['metric'] = metric ? metric : state.dataSet.metric
        // returnConfig['breakup'] = breakup ? breakup : state.dataSet.breakup
        // returnConfig['startDate'] = startDate ? startDate : state.dataSet.startDate
        // returnConfig['endDate'] = endDate ? endDate : state.dataSet.endDate
        // returnConfig['include'] = include ? include : state.dataSet.include
        // returnConfig['exclude'] = exclude ? exclude : state.dataSet.exclude
        // returnConfig['period'] = period ? period : state.dataSet.period
        // returnConfig['point'] = state.dataSet.point ? state.dataSet.point : state.dataSet.property

        returnConfig['property'] = property
        returnConfig['metric'] = metric
        returnConfig['breakup'] = breakup
        returnConfig['startDate'] = startDate
        returnConfig['endDate'] = endDate
        returnConfig['include'] = include
        returnConfig['exclude'] = exclude
        returnConfig['period'] = period
        returnConfig['point'] = insightPoint
        returnConfig['insightDate'] = insightDate
        returnConfig['chart'] = chartCat

    }
    
    return returnConfig
    // if(state.dataSet.point){
        
    //     return {
    //         // property: state.dataSet.property,
    //         authData: state.dataSet.authData,
    //         // point: state.dataSet.point ? state.dataSet.point : state.dataSet.property,
    //         // propertyDisp: state.dataSet.propertyDisp,
    //         breakup: state.dataSet.breakup,
    //         breakupDisp: state.dataSet.breakupDisp,
    //         insightDate: state.dataSet.insightDate,
    //         // metric: state.dataSet.metric,
    //         startDate: state.dataSet.startDate,
    //         endDate: state.dataSet.endDate,
    //         mainMetric: state.dataSet.metricGlobal,
    //         dashboard_config: dashboardConfig,
    //         newPage: newPage
    //     }
    // }else {
    //     return {
    //         newPage: newPage
    //     }
    // }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setInsightFunction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarInsight);